import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {ExpenseDetailsState, getInitialState} from '@web/slices/expenseDetails/slice'

import {MakeSliceOptions, SliceReducers} from '../interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<ExpenseDetailsState, SliceReducers, 'expendDetails', SliceSelectors<ExpenseDetailsState>>({
        name: 'expendDetails',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.expenseDetails ?? state
            })
        },
    })
